import { render, staticRenderFns } from "./techerDisplayWidge.vue?vue&type=template&id=66858859&scoped=true"
import script from "./techerDisplayWidge.vue?vue&type=script&lang=js"
export * from "./techerDisplayWidge.vue?vue&type=script&lang=js"
import style0 from "./techerDisplayWidge.vue?vue&type=style&index=0&id=66858859&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66858859",
  null
  
)

export default component.exports